module.exports = __webpack_public_path__ + "media/application/images/icons/confidence-level-3-e6ac569a7e19cdd4cba02c4c3c31d661.svg";